<template>
  <div>
    <b-row>
      <b-col>
        <a-divider orientation="left">Agregar proyecto
          <b-button variant="primary" @click="create()" style="position: absolute; right: 2rem; top: -0.5em; z-index: 1;">Crear</b-button>
        </a-divider>
        <b-collapse id="collapse-1" class="mt-2" v-model="visibleCollapse">
          <b-card>
            <academicProjectCreate v-if="visibleCollapse" @clean="clean" :isEditing="isEditing"></academicProjectCreate>
          </b-card>
        </b-collapse>
      </b-col>
    </b-row>
    <b-row>
      <div class="col">
        <b-table v-show="projects.length > 0 && !visibleCollapse" striped hover :fields="columns" :items="projects" head-variant="light" responsive>
          <template #cell(date)="projects">
            {{ moment(projects.item.createdAt).format('YYYY-MM-DD')  }}
          </template>
          <template #cell(actions)="projects">
            <div>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>Ver información</span>
                </template>
                <button type="button" @click="() => openModal(projects.item.id)" class="btn btn-light mr-2">
                  <i class="fa fa-eye text-blue" />
                </button>
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>Editar</span>
                </template>
                <button type="button" @click="() => sendEditId(projects.item.id)" class="btn btn-light mr-2">
                  <i class="fa fa-pencil text-blue" />
                </button>
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>Descargar documento</span>
                </template>
                <button type="button" @click="() => downloadProject(projects.item)" class="btn btn-light mr-2">
                  <i class="fa fa-download text-blue" />
                </button>
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>Eliminar</span>
                </template>
                <button type="button" @click="() => deletePost(projects.item)" class="btn btn-light mr-2">
                  <i class="fa fa-trash text-red" />
                </button>
              </a-tooltip>
            </div>
          </template>
        </b-table>
        <emptyTable v-show="projects.length < 1 && !visibleCollapse" />
      </div>
    </b-row>
    <b-row v-show="projects.length > 0 && !visibleCollapse">
      <b-col>
        <b-pagination
          v-model="pagination.currentPage"
          :total-rows="pagination.rows"
          :per-page="pagination.perPage"
          @input="search()"
          aria-controls="my-table"
        ></b-pagination>
      </b-col>
      <b-col class="text-right">
        {{ pagination.rows }} resultados
      </b-col>
    </b-row>
    <b-modal id="preview" ref="modal" size="lg" :title="'Proyecto #'+ preview.id" hide-footer>
      <div class="card-body pt-3 pb-0">
        <b-row class="m-auto" v-if="preview.resume !== null">
          <b>Resumen:</b>
        </b-row>
        <b-row class="m-auto pb-3" v-if="preview.resume !== null">
          {{ preview.resume }}
        </b-row>
        <b-row class="m-auto" v-if="preview.objectives !== null">
          <b>Objetivos:</b>
        </b-row>
        <b-row class="m-auto pb-3" v-if="preview.objectives !== null">
          {{ preview.objectives }}
        </b-row>
        <b-row class="m-auto" v-if="preview.finishedProduct !== null">
          <b>Producto entregado:</b>
        </b-row>
        <b-row class="m-auto pb-3" v-if="preview.finishedProduct !== null">
          {{ preview.finishedProduct }}
        </b-row>
        <b-row class="m-auto" v-if="preview.achievedImpact !== null">
          <b>Impacto obtenido:</b>
        </b-row>
        <b-row class="m-auto pb-3" v-if="preview.achievedImpact !== null">
          {{ preview.achievedImpact }}
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import apiClient from '@/services/axios'
import axios from 'axios'
import store from 'store'
import emptyTable from '@/components/custom/cardEmptyList'
import academicProjectCreate from '@/components/custom/academicProjectCreate'
import moment from 'moment'
import Swal from 'sweetalert2'
import { showErrorMessage } from '@/services/utilities'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  components: {
    emptyTable,
    academicProjectCreate,
  },
  name: 'academicProjectList',
  props: {
    dataInfo: {
      type: Object,
    },
  },
  data() {
    return {
      moment,
      isEditing: {
        value: false,
        id: '',
      },
      columns: [
        { key: 'id', label: 'Código', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'title', label: 'Titulo', thClass: 'text-center' },
        { key: 'date', label: 'Fecha de Creación', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      projects: [],
      search: '',
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      preview: {
        id: '',
        title: '',
      },
      visibleCollapse: false,
    }
  },
  created: function () {
  },
  mounted: function () {
    this.searchProjects()
  },
  updated: function () {
  },
  beforeDestroy: function () {
  },
  methods: {
    onHidden (e) {
    },
    openModal(id) {
      apiClient.get(`/academic-projects/${id}`).then(response => {
        this.preview = response.data
        this.$bvModal.show('preview')
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    deletePost(project) {
      Swal.fire({
        title: 'Confirmar eliminación',
        text: '¿Desea eliminar el proyecto ' + project.title + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          apiClient.delete(`/academic-projects/${project.id}`).then(response => {
            Toast.fire({
              icon: 'success',
              title: 'Post eliminado correctamente',
            })
            this.searchProjects()
          }).catch(error => {
            Toast.fire({
              icon: 'warning',
              title: 'Ooops ocurrió un error' + showErrorMessage(error),
            })
          })
        }
      })
    },
    downloadProject(project) {
      let url = ''
      url = process.env.VUE_APP_API_URL + `/academic-projects/download-project/${project.id}`
      const headers = {
        Authorization: `Bearer ${store.get('accessToken')}`,
        AccessToken: store.get('accessToken'),
      }
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        console.log(url)
        const link = document.createElement('a')
        link.href = url
        const filename = `Documento_Técnico_${project.title}.pdf`
        link.setAttribute('download', filename) // or any other extension
        document.body.appendChild(link)
        link.click()
        Toast.fire({
          icon: 'success',
          title: 'Proyecto descargado correctamente',
        })
      }).catch(error => {
        console.log(error)
        Toast.fire({
          icon: 'warning',
          title: 'Ooops ocurrió un error',
        })
      })
    },
    create() { // Boton crear
      this.visibleCollapse = !this.visibleCollapse
    },
    clean(type) {
      this.form = {
        id: null,
        title: '',
        resume: '',
        keyWords: [],
        objectives: '',
        finishedProduct: '',
        achievedImpact: '',
      }
      this.isEditing = {
        value: false,
        id: '',
      }
      this.visibleCollapse = false
      if (type === 1) {
        this.searchProjects()
      }
    },
    searchProjects() {
      let q = ''
      if (this.search) {
        q += '&search=' + this.search
      }
      apiClient.get(`/academic-projects?page=${this.pagination.currentPage - 1}&perpage=${this.pagination.perPage + q}`).then(response => {
        this.projects = response.data.projects
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    sendEditId(id) {
      this.isEditing = {
        id: id,
        value: true,
      }
      this.visibleCollapse = true
    },
  },
}
</script>
